<template>
<div>
  <v-row no-gutters justify="center" class="pt-3" style="height:196px;" v-show="isLoading">
    <div class="donutSpinner"></div>
  </v-row>
  <div v-show="!isLoading">
    <v-row no-gutters class="mx-4">
      <div id="3days-notification" class="3days-notification"/>
      <div class="mt-5">
        <span style="color: #000000;font-size:X-large;font-weight:bold;">{{ targetDayByDayFrom }} ～ {{ targetDayByDayTo }} の配送情報</span>
      </div>
      <v-spacer />
      <div class="mt-4">
        <v-chip label color="white" @click="calcBaseDate(-1)">
          <v-icon large style="width:20px">mdi-chevron-left</v-icon>
        </v-chip>
        <v-chip label color="white" @click="calcToday()"
        >
          <span style="font-size:large;font-weight:bold;">
            今日
          </span>
        </v-chip>
        <v-menu v-model="isShowCalendar" :close-on-content-click="false" origin="top left">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              style="margin-top: -2px"
              v-on="on"
              v-bind="attrs"
              color="primary"
              elevation="0"
              tabindex=-1
              icon
              dark
              small
              @click="onIconClick">
              <svg data-name="Icon - Calender" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
                <path d="M15.8,4A2.913,2.913,0,0,0,13,2V0H11V2H5V0H3V2A2.913,2.913,0,0,0,.2,4Z" fill="#83bde5"/>
                <path d="M0,5v8a2.946,2.946,0,0,0,3,3H13a2.946,2.946,0,0,0,3-3V5Zm5,8H3V11H5ZM5,9H3V7H5Zm4,4H7V11H9ZM9,9H7V7H9Zm4,0H11V7h2Z" fill="#83bde5"/>
              </svg>
            </v-btn>
          </template>
          <v-date-picker
            elevation="8"
            locale="jp-ja"
            v-model="baseYmd"
            :no-title="true"
            :day-format="date => new Date(date).getDate()"
            max="2999/12/31"
            min="2000/01/01"
            @input="onCalendarInput"
          >
            <v-spacer></v-spacer>
            <dd-default-button dark dense @click="isShowCalendar = false">閉じる</dd-default-button>
            <v-spacer></v-spacer>
          </v-date-picker>
        </v-menu>
        <v-chip label color="white" :disabled="targetDayByDayTo === currentDate" @click="calcBaseDate(1)">
          <v-icon large style="width:20px">mdi-chevron-right</v-icon>
        </v-chip>
      </div>
    </v-row>
    <hr class="mx-4" style="padding-top: 0px !important; padding-bottom: 0px !important; margin-top: 4px !important; margin-bottom: 0px !important;" color="#00ffdd" />
    <div class="pa-3">
      <v-row no-gutters>
        <v-col :lg="4" :xl="4" :cols="12" v-for="rec in dataList" :key="rec.index" class="px-2">
          <v-row no-gutters justify="center">
            <div class="text-black-bold" style="font-size:1.4rem">{{ rec.sagyoYoteiYmd }}</div>
          </v-row>
          <hr style="padding-top: 0px !important; padding-bottom: 0px !important; margin-top: 4px !important; margin-bottom: 0px !important;" color="#4682b4" />
          <table class="mx-1" style="width:100%">
            <tr class="day-by-day-row">
              <td width="50%" class="px-2 text-day-by-day-title">明細件数</td>
              <td width="50%" class="pr-2 text-day-by-day-data">{{ rec.meisaiCount }}件</td>
            </tr>
            <tr class="day-by-day-row">
              <td class="pl-2 text-day-by-day-title">稼働台数<br><span style="font-size:0.95rem !important">（自車／傭車）</span></td>
              <td>
                <div class="raito-div px-2">
                  <v-progress-linear
                    v-model="rec.sharyoPercent"
                    color="green"
                    height="30"
                    :readonly="true"
                  >
                    <template v-slot:default="{}">
                      <strong>{{ rec.jishaSharyoCount }}台/ {{ rec.yoshaSharyoCount }}台</strong>
                    </template>
                  </v-progress-linear>
                </div>
              </td>
            </tr>
            <tr height="25px">
              <td colspan="4" />
            </tr>
            <tr height="25px">
              <td class="px-2 text-day-by-day-title">売上</td>
              <td class="pr-2 text-day-by-day-data">{{ rec.uriageKingakuDisp }}円</td>
            </tr>
            <tr height="25px">
              <td class="px-2 text-day-by-day-title-2">傭車費</td>
              <td class="pr-2 text-day-by-day-data-2">{{ rec.yoshaShiharaiKingakuDisp }}円</td>
            </tr>
            <tr height="25px">
              <td class="px-2 text-day-by-day-title-2">経費</td>
              <td class="pr-2 text-day-by-day-data-2">{{ rec.KeihiKingakuDisp }}円</td>
            </tr>
            <tr height="10px">
              <td colspan="4">
                <hr style="padding-top: 0px !important; padding-bottom: 0px !important; margin-top: 4px !important; margin-bottom: 0px !important;" color="#4682b4" />
              </td>
            </tr>
            <tr class="day-by-day-row">
              <td class="px-2 text-day-by-day-title">限界利益</td>
              <td class="pr-2 text-day-by-day-data" :class="{ 'text-deficit': rec.genkaiRieki < 0 }">{{ rec.genkaiRiekiDisp }}円</td>
            </tr>
          </table>
        </v-col>
      </v-row>
    </div>
  </div>
</div>
</template>
<script>
import flowMixin from '@/mixins/flowMixins'
import complements from '@/rahmen/complement'
import filter from '@/rahmen/utils/filters'
import date from '@/ddv2.library/date'

import DdDefaultButton from '@/components/DdDefaultButton'

export default {
  name: 'DdUriageDayByDayDisp',
  mixins: [flowMixin],
  props: {
  },
  components: {
    DdDefaultButton
  },
  data: () => ({
    currentDate: null,
    targetDayByDayFrom: null,
    targetDayByDayTo: null,
    dataList: [],
    isLoading: false,
    isShowCalendar: false,
    baseYmd: null
  }),
  created () {
  },
  mounted () {
    console.log('DayBayDay')
    this.currentDate = date.getCurrentDate()
    this.baseYmd = date.getCurrentDate()
    this.calcBaseDate(null)
  },
  computed: {
    computedProps () {
      return {
        ...this.$props
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    }
  },
  methods: {
    searchDayByDaySummary: function (p) {
      this.isLoading = true
      const self = this
      console.log('searchDayByDaySummary')
      const conditions = {
        sagyoYoteiYmdFrom: this.targetDayByDayFrom,
        sagyoYoteiYmdTo: this.targetDayByDayTo,
        targetYmdType: p
      }
      self.HttpClient.post('/api/v1/VwCD2comd000002/Search', conditions)
        .then((data) => {
          self.dataList = data.payload
          if (p === '01') {
            self.dataList.map(x => {
              x.sagyoYoteiYmd = filter.dateFormatter(x.sagyoYoteiYmd)
              x.sharyoPercent = x.unkoCount === 0 ? 0 : x.jishaSharyoCount === 0 ? 0 : (x.jishaSharyoCount / x.unkoCount * 100).toFixed(2)
              x.genkaiRieki = x.uriageKingaku - x.yoshaShiharaiKingaku - (x.keihiKingaku ?? 0)

              x.uriageKingakuDisp = filter.numericFormatter(x.jishaUriageKingaku + x.yoshaUriageKingaku)
              x.jishaUriageKingakuDisp = filter.numericFormatter(x.jishaUriageKingaku)
              x.yoshaUriageKingakuDisp = filter.numericFormatter(x.yoshaUriageKingaku)
              x.yoshaShiharaiKingakuDisp = filter.numericFormatter(x.yoshaShiharaiKingaku)
              x.KeihiKingakuDisp = filter.numericFormatter(x.keihiKingaku)
              x.genkaiRiekiDisp = filter.numericFormatter(x.genkaiRieki)
            })
          } else if (p === '02') {
            self.dataList.map(x => {
              x.sagyoYoteiYmd = filter.dateFormatter(x.seikyuYoteiYmd)
              x.sharyoPercent = x.unkoCount === 0 ? 0 : x.jishaSharyoCount === 0 ? 0 : (x.jishaSharyoCount / x.unkoCount * 100).toFixed(2)
              x.genkaiRieki = x.uriageKingaku - x.yoshaShiharaiKingaku - (x.keihiKingaku ?? 0)

              x.uriageKingakuDisp = filter.numericFormatter(x.jishaUriageKingaku + x.yoshaUriageKingaku)
              x.jishaUriageKingakuDisp = filter.numericFormatter(x.jishaUriageKingaku)
              x.yoshaUriageKingakuDisp = filter.numericFormatter(x.yoshaUriageKingaku)
              x.yoshaShiharaiKingakuDisp = filter.numericFormatter(x.yoshaShiharaiKingaku)
              x.KeihiKingakuDisp = filter.numericFormatter(x.keihiKingaku)
              x.genkaiRiekiDisp = filter.numericFormatter(x.genkaiRieki)
            })
          }
          this.isLoading = false
        })
    },
    onIconClick: function (e) {
      console.log('DdDateBox.onIconClick', e, this.lazyValue)
      if (this.lazyValue !== null && this.lazyValue !== '' && this.lazyValue !== undefined) {
        var s = (complements.parseDate(this.lazyValue)).split('/')
        var d = new Date(s)
        if (isNaN(d.getDate())) {
          // 日付でない場合は処理日を設定
          this.baseYmd = date.getCurrentDate().split('/').join('-')
        } else {
          this.baseYmd = (complements.parseDate(this.lazyValue)).split('/').join('-')
        }
      } else {
        this.baseYmd = date.getCurrentDate().split('/').join('-')
      }
    },
    onCalendarInput: function (e) {
      console.log(e)
      this.isShowCalendar = false
      this.baseYmd = e.split('-').join('/')
      this.lazyValue = this.baseYmd
      this.calcBaseDate(null)
    },
    // 日付計算
    calcToday: function () {
      this.baseYmd = date.getCurrentDate()
      this.calcBaseDate(null)
    },
    calcBaseDate: function (val) {
      if (val === null) {
        const tmpDate1 = new Date(this.baseYmd)
        const tmpYmd1 = new Date(tmpDate1)
        tmpYmd1.setDate(tmpDate1.getDate() - 1)
        this.targetDayByDayFrom = `${tmpYmd1.getFullYear()}/${String(tmpYmd1.getMonth() + 1).padStart(2, '0')}/${String(tmpYmd1.getDate()).padStart(2, '0')}`

        const tmpDate2 = new Date(this.baseYmd)
        const tmpYmd2 = new Date(tmpDate2)
        tmpYmd2.setDate(tmpDate2.getDate() + 1)
        this.targetDayByDayTo = `${tmpYmd2.getFullYear()}/${String(tmpYmd2.getMonth() + 1).padStart(2, '0')}/${String(tmpYmd2.getDate()).padStart(2, '0')}`
      } else {
        const tmpDate1 = new Date(this.targetDayByDayFrom)
        const tmpYmd1 = new Date(tmpDate1)
        tmpYmd1.setDate(tmpDate1.getDate() + val)
        this.targetDayByDayFrom = `${tmpYmd1.getFullYear()}/${String(tmpYmd1.getMonth() + 1).padStart(2, '0')}/${String(tmpYmd1.getDate()).padStart(2, '0')}`

        const tmpDate2 = new Date(this.targetDayByDayFrom)
        const tmpYmd2 = new Date(tmpDate2)
        tmpYmd2.setDate(tmpDate2.getDate() + 2)
        this.targetDayByDayTo = `${tmpYmd2.getFullYear()}/${String(tmpYmd2.getMonth() + 1).padStart(2, '0')}/${String(tmpYmd2.getDate()).padStart(2, '0')}`
      }
      this.$emit('onChangeTargetYmd')
    }
  }
}
</script>
<style scoped>
.day-by-day-row {
  height: 35px;
}
.text-day-by-day-title {
  color: #483d8b;
  font-weight: bold;
  font-size: 1.1rem;
}
.text-day-by-day-title-2 {
  color: #a82323;
  font-size: 1.1rem;
  font-weight: bold;
}
.text-day-by-day-data {
  font-weight: bold;
  font-size: 1.1rem;
  text-align: right;
  color: #1F2B38;
}
.text-day-by-day-data-2 {
  font-weight: bold;
  font-size: 1.1rem;
  text-align: right;
  color: #a82323;
}

.donutSpinner {
  display: inline-block;
  border: 4px solid #E5EDFF;
  border-left-color: #5850EB;
  border-radius: 50%;
  width: 150px;
  height: 150px;
  animation: donut-spin 1.2s linear infinite;
}

@keyframes donut-spin {
  to {
    transform: rotate(1turn);
  }
}

.text-deficit {
  color: red;
}
</style>
